// MOTOR
export const GET_MOTOR = 'getMotor';
export const GET_SEARCH_VEHICLE = 'getSearchVehicle';
export const UPDATE_VALUE = 'updateValue';
export const GET_PREMIUM = 'getPremium';
// TRAVEL
export const GET_TRAVEL = 'getTravel';
// HOME
export const GET_HOME = 'getHome';
// DRIVER
export const GET_DRIVER = 'getDriver';
// HUNTER
export const GET_HUNTER = 'getHunter';
// OFFER
export const ADD_OFFER = 'addOffer';
export const DELETE_OFFER = 'deleteOffer';
export const GET_OFFERS = 'getOffers';
// CONTRACT
export const GET_CONTRACTS = 'getContracts';
// LOGIN
export const LOGIN_USER = 'loginUser';
export const LOGOUT_USER = 'logoutUser';
